import { Component, EventEmitter, OnInit, Output } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { MatInput } from '@angular/material/input'
import { ContactService } from '../../../core/services/contact/contact/contact.service'
import { ContactTypeService } from '../../../core/services/contact/contact-type/contact-type.service'
import { MatSelectModule } from '@angular/material/select'

@Component({
  selector: 'contact-create',
  imports: [
    ReactiveFormsModule,
    MatButton,
    MatProgressSpinner,
    MatFormField,
    MatInput,
    MatLabel,
    MatSelectModule,
  ],
  templateUrl: './contact-create.component.html',
  styleUrl: './contact-create.component.scss',
  providers: [ContactService, ContactTypeService],
  standalone: true,
})
export class ContactCreateComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private contactService: ContactService,
    private contactTypeService: ContactTypeService,
    private snackbar: SnackbarCustomService,
  ) {}

  @Output() responseCreate = new EventEmitter()

  form: FormGroup = new FormGroup({})
  loading: boolean = false
  listType: any[] = []

  ngOnInit(): void {
    this.listTypeContact()
    this.createForm()
  }

  listTypeContact() {
    this.contactTypeService.listContactType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listType = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  createItem() {
    this.loading = true
    const model = this.createModel()
    this.contactService.createContact(model).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        this.responseCreate.emit()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
        this.form.reset()
      },
    })
  }

  createModel() {
    return {
      pessoaId: 0,
      descricao: this.form.controls['description'].value,
      tipoContatoId: this.form.controls['typeContact'].value,
    }
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      description: ['', [Validators.required]],
      typeContact: ['', [Validators.required]],
    })
  }
}
